import React from "react";
import styled from "@emotion/styled";
import { useApiRequest } from "@utils/ApiRequest";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@libs/reactQuery/queryClient";

const LikeButtonContainer = styled.button`
  display: flex;
  animation: ${({ liked }: { liked: boolean }) =>
    liked ? "bounce 0.3s" : "none"};

  @keyframes bounce {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.2);
    }
  }
`;
type Props = {
  children: React.ReactNode;
  isLiked: boolean;
  productId: number;
};
const ProductLikedButton = ({ children, isLiked, productId }: Props) => {
  const { patchProductLike } = useApiRequest();

  const handleLike = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    mutate();
  };

  const { mutate } = useMutation({
    mutationFn: () => patchProductLike(productId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["wishList"],
        exact: false,
      });
      await queryClient.invalidateQueries({
        queryKey: ["searchProductList"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["productList"],
      });
      await queryClient.invalidateQueries({
        queryKey: ["savedProductList"],
      });
    },
  });

  return (
    <LikeButtonContainer onClick={handleLike} liked={isLiked}>
      {children}
    </LikeButtonContainer>
  );
};

export default ProductLikedButton;
